import moment from "moment-timezone";
import { DateInput, DateTimeInput, TextInput } from "react-admin";
import { useForm } from "react-final-form";

export const MyDateTimeInput = (props) => {
  const { showSeconds = false, showTime = true, inputProps, ...inputPropsWithoutSeconds } = props;

  const format = (dataDate) => {
    if (!dataDate) {
      return null;
    }

    //Create moment object in UTC+8 timezone
    const d = moment.tz(dataDate, "Asia/Hong_Kong");
    const r = d.format(
      showTime ? (showSeconds ? "YYYY-MM-DDTHH:mm:ss" : "YYYY-MM-DDTHH:mm") : "YYYY-MM-DD"
    );

    return r;
  };

  const parse = (dataDate) => {
    if (!dataDate) {
      return null;
    }

    let value = dataDate;
    if (inputPropsWithoutSeconds.defaultValue) {
      value = inputPropsWithoutSeconds.defaultValue;
    }
    const d = moment.tz(value, "Asia/Hong_Kong");
    return d.toDate();
  };

  // parse and format for input text "no value"
  const noValueText = "no value";
  const formatText = (data) => {
    if (!data) return noValueText;
    return data;
  };
  const parseText = (text) => {
    if (text == noValueText) return null;
    return text;
  };

  // get its value from the form
  const form = useForm();
  const formValues = form.getState().values;

  if (
    Object.prototype.hasOwnProperty.call(inputPropsWithoutSeconds, "disabled") &&
    inputPropsWithoutSeconds.disabled != false &&
    !formValues[inputPropsWithoutSeconds.source]
  ) {
    return <TextInput {...inputPropsWithoutSeconds} format={formatText} parse={parseText} />;
  } else {
    const InputComponent = showTime ? DateTimeInput : DateInput;

    return (
      <InputComponent
        {...inputPropsWithoutSeconds}
        inputProps={{
          ...inputProps,
          max:
            inputProps?.max ||
            (showTime ? (showSeconds ? "2999-12-31T00:00:00" : "2999-12-31T00:00") : "2999-12-31"),
          ...(showTime && showSeconds ? { step: 1 } : {}),
        }}
        parse={(val) => parse(val)}
        format={(val) => format(val)}
      />
    );
  }
};
